module.exports = __webpack_public_path__ + "static/media/cog.adde8ee8.png";